import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { InteractiveScheduleComponent } from './interactive-schedule.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

const routes: Routes = [
  { path: '', component: InteractiveScheduleComponent, data: { title: 'Interactive Schedule' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InteractiveScheduleRoutingModule {}

@NgModule({
  imports: [
    InteractiveScheduleRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    DragDropModule,
  ],
  declarations: [InteractiveScheduleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [InteractiveScheduleComponent],
})
export class InteractiveScheduleModule {}
